const officeAppsSrc = 'https://view.officeapps.live.com/op/embed.aspx?src=' as const;

type Extension = 'doc' | 'docx' | 'xls' | 'xlsx' | 'ppt' | 'pptx' | 'odt' | 'dwg' | 'pdf';

const iframeSources: Record<Extension, string> = {
    doc: officeAppsSrc,
    docx: officeAppsSrc,
    xls: officeAppsSrc,
    xlsx: officeAppsSrc,
    ppt: officeAppsSrc,
    pptx: officeAppsSrc,
    odt: officeAppsSrc,
    dwg: '//sharecad.org/cadframe/load?url=',
    pdf: '',
};

function isExtension(ext: string): ext is Extension {
    return ext in iframeSources;
}

export function getIframeSrc(extension: string): string | null {
    const lower = extension.toLowerCase();
    if (isExtension(lower)) {
        return iframeSources[lower];
    }
    return null;
}

// const officeAppsSrc = 'https://view.officeapps.live.com/op/embed.aspx?src=';
//
// const iframeSources = {
//     doc: officeAppsSrc,
//     docx: officeAppsSrc,
//     xls: officeAppsSrc,
//     xlsx: officeAppsSrc,
//     ppt: officeAppsSrc,
//     pptx: officeAppsSrc,
//     odt: officeAppsSrc,
//     dwg: '//sharecad.org/cadframe/load?url=',
//     pdf: '',
// };
//
// export const getIframeSrc = (extension: string) => {
//     const lowerCaseExtension = extension.toLowerCase();
//     return iframeSources.hasOwnProperty(lowerCaseExtension)
//         ? iframeSources[lowerCaseExtension]
//         : null;
// };
